import { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { 
    scanAndInsert,
} from './ScanUtilities.js';

function ReviewRedirect() {
    const { deviceId } = useParams();
    const hasTracked = useRef(false); // Add this ref

    useEffect(() => {
        const trackScanAndRedirect = async () => {
            // Prevent multiple executions
            if (hasTracked.current) return;
            hasTracked.current = true;

            let GoogleReviewLink = null;
            
            try {
                const GoogleReviewLink  = await scanAndInsert(deviceId);
                console.log('Google Review Link:', GoogleReviewLink);
                 
                if (GoogleReviewLink) {
                    window.location.href = GoogleReviewLink;
                    return;
                }
            } catch (error) {
                console.error('Failed to track scan:', error);
            }

            if (!GoogleReviewLink) {
                console.error('No Google review link found, redirecting to default review page');
                window.location.href = 'https://business.google.com/reviews';
            }
        };

        if (deviceId && !hasTracked.current) {
            trackScanAndRedirect();
        }
    }, [deviceId]);

    return (
        <div style={{ textAlign: 'center', padding: '50px' }}>
            <p>Redirecting to review page...</p>
        </div>
    );
}

export default ReviewRedirect;